(function () {
  function insertAfter(newNode, el) {
    el.parentNode.insertBefore(newNode, el.nextElementSibling);
  }

  if (window.ff) window.ff.insertAfter = insertAfter;
  else window.ff = { insertAfter: insertAfter };
})();
